import React from 'react'
import PT from 'prop-types'
import EditableCard from '@vimcar/shared-components/components/EditableCard'
import SwaggerForm from '@vimcar/shared-components/components/SwaggerForm'
import linkStore from '@vimcar/shared-utils/linkStore'

import Err from '#components/Err'
import i18n from '#utils/i18n'
import definitions from './definitions'
import mkStore from './store'
import styles from './styles.css'

const tp = i18n.prefix('components.ProfileCard')

const ProfileUser = ({
  loading,
  store = {},
}) => (
  <EditableCard
    editing={store.editing}
    loading={loading}
    onCancel={store.handleCancel}
    onEdit={store.handleEdit}
    onSave={store.handleSave}
    title={tp('title')}
    >
    {store.error && <Err>{store.error}</Err>}
    <SwaggerForm
      data={store.data}
      definition={definitions.profile}
      disabled={!store.editing}
      fieldProps={!store.editing && { classNameInner: styles.input }}
      fields={store.fields}
      i18n={i18n}
      onChange={store.handleChange}
      onSubmit={store.handleSave}
      />
  </EditableCard>
)

ProfileUser.propTypes = {
  loading: PT.bool.isRequired,
  store: PT.object.isRequired,
}

export default linkStore(mkStore, ProfileUser)
